import i18next from '@bonanza-social/i18n';
import en from './en.json';
import fr from './fr.json';

i18next.addResources('en', 'inviteFriends', en);
i18next.addResources('fr', 'inviteFriends', fr);

declare global {
  interface RegisteredLocales {
    inviteFriends: typeof en;
  }
}
